import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-br-black text-gray-300">
      <div className="container-br pt-16 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4" aria-label="Black Ridge Construction">
              <img src={SITE.logo} alt="Black Ridge Construction" className="h-32 w-auto object-contain" />
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed">
              Full-service residential general contractor serving Austin and Central Texas. Roofing, remodeling, repairs, additions, outdoor living, and ongoing maintenance.
            </p>
            <div className="mt-5 space-y-2 text-sm">
              <a href={`tel:${SITE.phoneE164}`} className="flex items-center gap-2 hover:text-br-bronze-2"><Phone size={14}/> {SITE.phone}</a>
              <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-br-bronze-2"><Mail size={14}/> {SITE.email}</a>
              <div className="flex items-center gap-2 text-gray-400"><MapPin size={14}/> {SITE.serviceArea}</div>
            </div>
          </div>
          <div>
            <h4 className="font-display tracking-widest text-white text-sm mb-4 uppercase">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link className="hover:text-br-bronze-2" to="/construction-services">All Construction Services</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/roofing">Roofing</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/remodeling">Remodeling</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/services/outdoor-living">Outdoor Living</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/services/home-additions">Home Additions</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/services/handyman-punch-list">Repairs & Punch List</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/services/investor-property-repairs">Investor Repairs</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/maintenance-plans">Maintenance Plans</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/commercial">Commercial</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/project-listings">Project Listings</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display tracking-widest text-white text-sm mb-4 uppercase">Service Areas</h4>
            <ul className="space-y-2 text-sm">
              <li><Link className="hover:text-br-bronze-2" to="/service-areas/austin-tx">Austin</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/service-areas/round-rock-tx">Round Rock</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/service-areas/cedar-park-tx">Cedar Park</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/service-areas/georgetown-tx">Georgetown</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/service-areas/leander-tx">Leander</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/service-areas/pflugerville-tx">Pflugerville</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/service-areas/kyle-tx">Kyle</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/service-areas">All service areas →</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display tracking-widest text-white text-sm mb-4 uppercase">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link className="hover:text-br-bronze-2" to="/about">About</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/careers">Careers</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/testimonials">Testimonials</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/blog">Resources / Blog</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/contact">Contact</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/subcontractor-partnerships">Subcontractor Partnerships</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/privacy">Privacy Policy</Link></li>
              <li><Link className="hover:text-br-bronze-2" to="/terms">Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-br-line text-xs text-gray-500 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <span>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</span>
            <span className="text-gray-700">·</span>
            <Link
              to="/admin/login"
              className="text-gray-600 hover:text-br-bronze-2 transition"
              data-testid="footer-admin-link"
              aria-label="Admin dashboard"
            >
              Admin
            </Link>
          </div>
          <div className="max-w-xl text-gray-500">
            Maintenance memberships are repair reserve agreements with defined covered scopes and limits. They are not home insurance, warranties, or unlimited-repair programs.
          </div>
        </div>
      </div>
    </footer>
  );
}
